import DeviceInfo from 'react-native-device-info';

// Must be hardcoded, as associated with Info.plist etc
export const DEEP_LINK_SCHEME_ID = DeviceInfo.getBundleId();

export const DEEP_LINK_SCHEME = `${DEEP_LINK_SCHEME_ID}://`;

// Use the per-flavor bundle-id scheme (registered on iOS Info.plist + Android manifest), same as
// the login callbacks below. The generic `sleepio://` scheme is NOT registered in the iOS
// Info.plist, so an iOS redirect to it fails with "address is invalid".
export const CREATE_ACCOUNT_CALLBACK = `${DEEP_LINK_SCHEME}create-account-callback`;

export const LOGIN_CALLBACK = `${DEEP_LINK_SCHEME}login-callback`;

export const LOGIN_EMAIL_CALLBACK = `${DEEP_LINK_SCHEME}login-email-callback`;

export const NHS_LOGIN_PATH = '/login-component/login';

export const NHS_ONBOARDING_PATH = '/sleepio/create-account';
